// extracted by mini-css-extract-plugin
export default {"container":"Copyright_container__A+TLQ","text":"Copyright_text__PkEMx","term":"Copyright_term__+78gq"};